<template>
  <b-form-tags
    :id="id"
    v-model="selectedTags"
    add-on-change
    no-outer-focus>
    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
      <b-form-select
        v-bind="inputAttrs"
        v-on="inputHandlers"
        class="mb-2"
        :disabled="disabled || availableItemsOptions.length === 0"
        :options="availableItemsOptions">
        <template #first>
          <!-- This is required to prevent bugs with Safari -->
          <option disabled value="">{{ placeholder }}</option>
        </template>
      </b-form-select>
      <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
        <li v-for="tag in tags" :key="tag" class="list-inline-item">
          <b-form-tag
            @remove="removeTag(tag)"
            :title="tag"
            :disabled="disabled">
            {{ tag }}
          </b-form-tag>
        </li>
      </ul>
      <div v-else class="selected-items-empty d-flex align-items-center">
        <span>{{ noSelection }}</span>
      </div>
    </template>
  </b-form-tags>
</template>

<script>
export default {

  name: 'SelectTagsField',

  props: {
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    noSelection: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    itemsInit: {
      type: Array,
      default() {
        return []
      }
    }
  },

  emits: ['didChangeSelectedItems'],

  data() {
    return {
      selectedTags: []
    }
  },

  watch: {
    'selectedTags': function () {
      let selectedItemsIds = []
      this.selectedTags.map(selectedTag => {
        let item = this.items.find(item => item.tostring === selectedTag)
        if (item) {
          selectedItemsIds.push(item.id)
        }
      })
      this.$emit('didChangeSelectedItems', selectedItemsIds)
    }
  },

  computed: {
    availableItemsOptions() {
      return this.items
        .filter(item =>
          this.selectedTags.indexOf(item.tostring) === -1
        ).map(item => (
          item.tostring
        ))
    }
  },

  mounted () {
    this.setInitialValues()
  },

  methods: {
    setInitialValues() {
      if (this.itemsInit) {
        this.itemsInit.forEach(item =>
          this.selectedTags.push(item.tostring)
        )
      }
    }
  }

}
</script>

<style scoped>

.b-form-tags {
  background: transparent;
  border: none;
  padding: 0;
}

.b-form-select {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid #dee2e6;
  box-shadow: none;
}

.b-form-tag {
  background: #EAEDF4;
  border: 1px solid #6D84C4;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  color: #07153C;
  font-size: 0.875rem;
}

.b-form-tag .close {
  margin-left: 0.5rem;
  font-size: 1.25rem;
  opacity: 0.7;
  color: #6c757d;
}

.b-form-tag .close:hover {
  opacity: 1;
  color: #dc3545;
}


.selected-items-empty {
  color: #6c757d;
  font-size: 0.875rem;
}

ul.list-inline {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
}

.list-inline-item {
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}




</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/SelectTagsField.vue